<template>
  <div>
    <div class="head_style head_height_style">
      <img
        src="../assets/img/logo.svg"
        class="logo_style"
        @click="logo_click"
      />
      <div class="tmall_style">
        <!-- <div class="head_style head_link_style">
          <div class="head_style1 head_margin_style" @click="cat_href_click">
            <img src="../assets/img/tm.png" class="cat_style" />
            <div>天猫店</div>
          </div>
          <div class="head_style1" @click="jd_href_click">
            <img src="../assets/img/jd.png" class="cat_style" />
            <div>京东店</div>
          </div>
        </div> -->
      </div>
      <div class="head_style head_link_style1">
        <div>
          <ul class="ignore switch">
            <!-- <li><a href="javascript:translate.changeLanguage('chinese_simplified');" :style="[{ 'font-weight': activeLanguage == 'chinese_simplified' ? 'bold' : '' }]">CN</a></li>|
            <li><a href="javascript:translate.changeLanguage('english');" :style="[{ 'font-weight': activeLanguage == 'english' ? 'bold' : '' }]">EN</a></li>|
            <li><a href="javascript:translate.changeLanguage('japanese');" :style="[{ 'font-weight': activeLanguage == 'japanese' ? 'bold' : '' }]">JP</a></li> -->
            <!-- 这个新的 -->
            <!-- <li><a href="javascript:translate.changeLanguage('chinese_simplified');">CN</a></li>|
            <li><a href="javascript:translate.changeLanguage('english');">EN</a></li>|
            <li><a href="javascript:translate.changeLanguage('japanese');">JP</a></li> -->
          </ul>
        </div>
        <div class="question_style" @click="question_click">
          <i class="el-icon-question"></i>
        </div>
        <!-- <img
          style="width: 30px"
          src="../assets/img/cart.png"
          @click="cart_click"
          class="cart_style"
        /> -->
        <div v-if="!cgmUserVO" @click="login_click" class="login_button_style">
          <span class="login_style">登录</span>
        </div>
        <!-- <div v-if="!cgmUserVO" @click="register_click">
          <span class="register_style">注册</span>
        </div> -->
        <!-- @click="user_click" -->
        <!-- <div v-if="cgmUserVO">
          <span class="center_style">
            <el-dropdown trigger="click">
              <el-avatar icon="el-icon-user-solid"></el-avatar>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="user_config_click(1)"
                  >家庭配置药</el-dropdown-item
                >
                <el-dropdown-item @click.native="user_family_click(2)"
                  >我的家庭</el-dropdown-item
                >
                <el-dropdown-item @click.native="order_click(3)"
                  >账单和物流</el-dropdown-item
                >
                <el-dropdown-item @click.native="user_address_click(4)"
                  >收货地址</el-dropdown-item
                >
                <el-dropdown-item @click.native="login_out_click"
                  >退出登录</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </div> -->
        <div class="menu_style">
          <!-- <i
            v-if="cgmUserVO"
            class="el-icon-s-operation"
            @click="nav_click"
          ></i> -->
          <img
            v-if="cgmUserVO"
            @click="nav_click"
            src="../assets/img/logged_icon.png"
            alt=""
            style="width: 52px; vertical-align: middle"
          />
        </div>
      </div>
      <el-dialog
        title="注册"
        :visible.sync="loginDialogVisible"
        width="42%"
      >
        <div class="lo_style">登录或注册才可以进行预定。</div>
        <div class="lo_style">
          点击「注册」「登录」即表示您同意
          <span class="log_style" @click="pro1_click">利用规约</span>
          以及
          <span class="log_style" @click="pro2_click">隐私条款</span
          >注册时请务必填写真实个人信息
        </div>
        <div class="log_create_style">
          <div @click="login_click1" class="log1_create_style">
            登录账户
          </div>
          <div @click="register_click" class="log2_create_style">
            创建家庭账户
          </div>
        </div>
        <div class="log3_create_style">需要帮助时请联络工作人员</div>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="navigationDialogVisible"
        width="42%"
        class="navigation_style"
      >
        <div>
          <div class="menu_layout_style" @click="user_config_click(1)">
            <div class="menu_title_style">家庭配置药</div>
            <div class="menu_arrow_style">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="menu_layout_style" @click="user_family_click(2)">
            <div class="menu_title_style">我的家庭</div>
            <div class="menu_arrow_style">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="menu_layout_style" @click="order_click(3)">
            <div class="menu_title_style">账单和物流</div>
            <div class="menu_arrow_style">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="menu_layout_style" @click="user_address_click(4)">
            <div class="menu_title_style">收货地址</div>
            <div class="menu_arrow_style">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="menu_layout_style" @click="login_out_click">
            <div class="menu_title_style1">退出登录</div>
            <div class="menu_arrow_style">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>

        <!-- <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <div class="nav_font_style">家庭配置药</div>
            </template>
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <div class="nav_font_style">我的家庭</div>
            </template>
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <div class="nav_font_style">账单和物流</div>
            </template>
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <div class="nav_font_style">收货地址</div>
            </template>
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <div class="nav_logout_style">退出登录</div>
            </template>
          </el-collapse-item>
        </el-collapse> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  cat_href,
  jd_href,
  city_href,
  operation_href,
  prescription_href,
  prescription_search_href,
  express_href,
  agreement_href,
  protect_href,
  site_href,
  pro1_href,
  pro2_href,
} from "../assets/config/img";
export default {
  computed: {
    ...mapState(["cgmUserVO", "leftItem", "mobile"]),
  },
  data() {
    return {
      loginDialogVisible: false,
      navigationDialogVisible: false,
      language:0
      // activeLanguage: "chinese_simplified"
    };
  },
  mounted() {
    // this.language = window.translate.language.getCurrent();
    // console.log('这里的'+ window.translate.language.getCurrent())
    // if(this.language == "english"){
    //   import('../assets/english.css');
    // }
    // if(this.language == "japanese"){
    //   import('../assets/japanese.css');
    // }
  },
  methods: {
    ...mapMutations(["setCgmUserVO", "setLeftItem"]),
    question_click() {
      this.$router.push({
        path: "/question",
      });
    },
    nav_click() {
      if (this.mobile) {
        // this.navigationDialogVisible = true;
        this.$router.push({
          path: "/menu",
        });
      } else {
        this.setLeftItem(1);
        this.$router.push({
          path: "/userCenter",
        });
      }
    },
    cart_click() {
      this.$router.push("/spu?packageId=1731336393415692289");
    },
    pro1_click() {
      window.open(pro1_href);
    },
    pro2_click() {
      window.open(pro2_href);
    },
    user_center_click() {
      this.$router.push("/userCenter");
    },
    user_config_click(v) {
      if (this.mobile) {
        this.navigationDialogVisible = false;
        this.$router.push("/userConfig");
      } else {
        this.setLeftItem(v);
        this.$router.push({
          path: "/userCenter",
        });
      }
    },
    user_family_click(v) {
      if (this.mobile) {
        this.navigationDialogVisible = false;
        this.$router.push("/userFamily");
      } else {
        this.setLeftItem(v);
        this.$router.push({
          path: "/userCenter",
        });
      }
    },
    order_click(v) {
      if (this.mobile) {
        this.navigationDialogVisible = false;
        this.$router.push("/order");
      } else {
        this.setLeftItem(v);
        this.$router.push({
          path: "/userCenter",
        });
      }
    },
    user_address_click(v) {
      if (this.mobile) {
        this.navigationDialogVisible = false;
        this.$router.push("/userAddress");
      } else {
        this.setLeftItem(v);
        this.$router.push({
          path: "/userCenter",
        });
      }
    },
    login_out_click() {
      this.navigationDialogVisible = false;
      this.setCgmUserVO(null);
      this.$router.push("/");
    },
    info_click() {
      this.$router.push("/cgmUserVO");
    },
    logo_click() {
      if (this.cgmUserVO) {
              let userId = JSON.parse(this.cgmUserVO).userId;
              this.axios
                .get("/cgmOrder/getOrderCount", {
                  params: {
                    userId,
                  },
                })
                .then((res) => {
                  if (res.data.code == 200) {
                    this.configFlag = res.data.data;
                    if(res.data.data > 0){
                      this.$router.push("/ConfigMedicine");
                    }else{
                      this.$router.push("/Firstindex");
                    }
                  }
                });
              }else{
                this.$router.push("/Firstindex");
              }
    },
    login_click() {
      // this.$router.push("/Login");
      this.loginDialogVisible = true;
    },
    login_click1() {
      this.$router.push("/login");
      this.loginDialogVisible = false;
    },
    register_click() {
      this.$router.push("/register");
      this.loginDialogVisible = false;
    },
    user_click() {
      this.$router.push("/user");
    },
    cat_href_click() {
      window.open(cat_href);
    },
    jd_href_click() {
      window.open(jd_href);
    },
    city_href_click() {
      window.open(city_href);
    },
    operation_href_click() {
      window.open(operation_href);
    },
    prescription_href_click() {
      window.open(prescription_href);
    },
    prescription_search_href_click() {
      window.open(prescription_search_href);
    },
    express_href_click() {
      window.open(express_href);
    },
    agreement_href_click() {
      window.open(agreement_href);
    },
    protect_href_click() {
      window.open(protect_href);
    },
    site_href_click() {
      window.open(site_href);
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 768px) {
  .menu_style {
    margin-left: 4px;
  }
  .tmall_style {
    display: none;
  }
  .content_style > div {
    color: red;
    width: unset;
  }
  .des_style {
    flex-wrap: wrap;
  }
  .carousel_style {
    width: 100%;
  }
  .head_margin_style {
    margin-right: unset !important;
  }
  .head_style .head_link_style {
    gap: 10px;
  }
  .head_style .head_link_style1 {
    gap: 10px;
  }
  .head_style {
    // justify-content: space-around !important;
    // padding-left: unset !important;
    // padding-right: unset !important;
    // gap: unset !important;
    // padding:0 15px;
  }
  ::v-deep .el-dialog {
    width: 100% !important;
  }
  .question_style {
    display: none;
  }
  .pc_dropdown_menu_style {
    display: none;
  }
}
@media (min-width: 768px) {
  .dropdown_menu_style {
    display: none;
  }
}
.switch{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px
}
.lan_style{
  cursor: pointer;
}
::v-deep .el-icon-s-operation {
  vertical-align: middle;
}
::v-deep .el-icon-question {
  vertical-align: middle;
}
.tmall_style {
  margin-left: 116px;
}
.head_link_style1 {
  gap: 16px;
}
.head_margin_style {
  margin-right: 32px;
}
.language_style {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px
}
.cn_style {
  font-weight: bold;
}
.menu_layout_style {
  display: flex;
  justify-content: space-between;
  // height: 60px;
  align-items: center;
  font-weight: bold;
  font-size: 17px;
}
.menu_title_style1 {
  color: #f56c6c;
}
.menu_style {
  cursor: pointer;
  font-size: 26px;
}
.nav_font_style {
  font-size: 16px;
  font-weight: bold;
}
.nav_logout_style {
  color: #f56c6c;
  font-size: 16px;
  font-weight: bold;
}
.question_style {
  cursor: pointer;
  font-size: 22px;
}
.cart_style {
  cursor: pointer;
}
.log_create_style {
  background: rgb(245, 246, 247);
  padding: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: 20px 0;
}
.log1_create_style {
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  background: rgb(229, 28, 81);
  color: rgb(255, 255, 255);
  border-radius: 8px;
  width: 300px;
  height: 54px;
  line-height: 54px;
}
.log2_create_style {
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  background: #fff;
  color: rgb(34, 51, 68);
  border-radius: 8px;
  width: 300px;
  height: 54px;
  line-height: 54px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.log3_create_style {
  color: rgb(119, 136, 153);
  font-weight: bold;
  margin-top: 16px;
  text-align: center;
  font-size: 12px;
}
.log_style {
  color: rgb(229, 28, 81);
  cursor: pointer;
}
.lo_style {
  color: #000;
  margin-top: 7px;
}
::v-deep .navigation_style .el-dialog {
  margin-top: unset !important;
  height: 100vh !important;
}
::v-deep .navigation_style .el-dialog__body {
  margin-top: 40px !important;
}
::v-deep .navigation_style .el-dialog__headerbtn {
  padding: 11px;
  font-size: 11px;
}
::v-deep .el-dialog {
  border-radius: 10px;
}
::v-deep .el-dialog__title {
  font-weight: bold;
  color: rgb(34, 51, 68);
  font-size: 24px;
}
::v-deep .el-dialog__headerbtn {
  padding: 16px;
  border: 1px solid rgb(68, 85, 102);
  background: rgb(68, 85, 102);
  border-radius: 200px;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.head_style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 24px;
  padding-right: 8px;
  // gap: 20px;
}

.head_height_style {
  height: 60px;
  border-bottom: 1px solid #e5e9f0;
}

.head_style1 {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
  gap: 4px;
}

.logo_style {
  width: 140px;
  cursor: pointer;
}

.cat_style {
  width: 24px;
}

// .login_button_style {
//   margin-left: 4px;
// }

.login_style {
  // background: rgb(229, 28, 81);
  background:#FF1313;
  color: #fff;
  font-weight: bold;
  border-radius: 200px;
  padding: 10px 24px;
  cursor: pointer;
}
.center_style {
  cursor: pointer;
}
.register_style {
  background: #409eff;
  color: #fff;
  font-weight: bold;
  border-radius: 100px;
  padding: 8px 16px;
  cursor: pointer;
}

.footer_style {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
@media (max-width: 820px) {
  .login_style{
    padding:8px 10px;
    font-size: 12px;
  }
  .head_link_style.head_style{
    padding-left: 10px;
  }
  .head_style {
    // justify-content: space-around !important;
    // padding-left: unset !important;
    // padding-right: unset !important;
    // gap: unset !important;
    padding:0 2px 0 15px;
  }
}
</style>